/** @format */

import React from "react";
import {
  AiFillGithub,
  AiOutlinePhone,
  AiOutlineMail,
  AiOutlineInstagram,
  AiOutlineLinkedin,
} from "react-icons/ai";
import { PiTelegramLogoDuotone } from "react-icons/pi";
const Contacts = () => {
  return (
    <section className='section-three grid relative lg:text-xl'>
      <ul className='grid gap-5'>
        <li className='shadow-link'>
          <a
            href='https://github.com/OmniaCrystalline'
            target='_blanck'
            className='flex gap-3 m-auto justify-center'>
            <AiFillGithub className='my-auto' />
            GitHub
          </a>
        </li>
        <li className='shadow-link'>
          <a
            href='tel:0505541315'
            target='_blanck'
            className='flex gap-3 m-auto justify-center'>
            <AiOutlinePhone className='my-auto' />
            0505541315
          </a>
        </li>
        <li className='shadow-link'>
          <a
            href='mailto:mospan.vira@gmail.com'
            className='flex gap-3 justify-center'
            target='_blanck'>
            <AiOutlineMail className='my-auto' />
            mospan.vira@gmail.com
          </a>
        </li>
        <li className='shadow-link '>
          <a
            href='https://t.me/@Risen_Sun'
            className='flex gap-3 justify-center'
            target='_blanck'>
            <PiTelegramLogoDuotone className='my-auto' />
            @Risen_Sun
          </a>
        </li>
        <li className='shadow-link'>
          <a
            href='https://instagram.com/vera.mospan.14?igshid=ZGUzMzM3NWJiOQ=='
            className='flex gap-3 justify-center'
            target='_blanck'>
            <AiOutlineInstagram className='my-auto' />
            Instagram
          </a>
        </li>
        <li className='shadow-link '>
          <a
            href='https://github.com/OmniaCrystalline'
            target='_blanck'
            className='flex gap-3 m-auto justify-center'>
            <AiOutlineLinkedin className='my-auto' />
            Linkedin
          </a>
        </li>
      </ul>
      <span className='absolute -top-[60px]' id='contacts'></span>
    </section>
  );
};

export default Contacts;
